export { ProductOfferLabel } from "./ProductOfferLabel";
export type { ProductOfferLabelProps } from "./ProductOfferLabel";
